import * as React from 'react';
type Props = {
  className?: string;
};
export function Heart3({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-heart3"
      className={className}
    >
      <path
        d="M18.3333 8.33331C18.3333 12.9166 9.99996 17.5 9.99996 17.5C9.99996 17.5 1.66663 12.9166 1.66663 8.33331C1.66663 5.41665 3.33329 3.33331 5.83329 3.33331C8.33329 3.33331 9.58329 4.86109 9.99996 5.41665C10.5555 4.86109 11.6666 3.33331 14.1666 3.33331C16.6666 3.33331 18.3333 5.41665 18.3333 8.33331Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}
